// ./client/src/pages/workspace/Messages.js
import React, { useEffect } from "react";
import { useAppContext } from "../../context/appContext";
import { MessageLog, NotifyEta, SendSms } from "../../components/Messages";
import { Display } from "../../components/workspace";

function Messages() {
  const { job, customer, contacts } = useAppContext();

  const defaultContact = contacts?.find((cnt) => cnt.id === job?.default_contact);
  const customerPhone = defaultContact?.phone;
  const enableTexting = defaultContact?.enable_texting;

  useEffect(() => {
    document.title = "Messages";
  }, []);

  return (
    <div className="messages page">
      <div className="group whole">
        {/* --- Current job's default contact --- */}
        <form className="form" onSubmit={(e) => e.preventDefault()}>
          <h3>Job Messages</h3>
          <div className="form-center">
            <div className="one-third">
              <Display name="Customer" value={customer?.customer_name} />
            </div>
            <div className="one-third">
              <Display name="Default Contact" value={defaultContact?.contact_name} />
            </div>
            <div className="one-third">
              <Display name="Phone" value={customerPhone} />
            </div>
          </div>
        </form>
      </div>
      <div className="group whole">
        {/* --- Notify customer of ETA --- */}
        <form className="form" onSubmit={(e) => e.preventDefault()}>
          <div className="form-center">
            <NotifyEta customerPhone={customerPhone} enableTexting={enableTexting} />
          </div>
        </form>
      </div>
      {/* --- Send a custom text --- */}
      <div className="group whole">
        <SendSms customerPhone={customerPhone} enableTexting={enableTexting} />
      </div>
      {/* --- Messages for this job --- */}
      <MessageLog jobId={job?.id} />
    </div>
  );
}
export default Messages;
